@for (tab of tabs; track tab) {
  <a (click)="onClick(tab)" [class.current]="tab?.current">{{ tab.name }} </a>
}
